import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, switchMap, takeUntil } from 'rxjs/operators'

import { getTimezoneId, getTZOffset } from 'utils/dateUtils'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import {
  selectActualFeatureFlags,
  selectHasSelectedCompanyFilterAccess,
  selectIsStaticSalesDemo,
} from 'containers/App/selectors'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'
import { addToast } from 'containers/Toasts/actions'

import { DATE_FILTER_CHANGE, SCANBACK_CHANGE } from '../constants'
import { selectDateRange } from '../selectors'

import { GET_DEEPFAKE_ANALYTIC_ASYNC } from './constants'

const createDeepfakeEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      GET_DEEPFAKE_ANALYTIC_ASYNC.INITIATE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      DATE_FILTER_CHANGE,
      SCANBACK_CHANGE
    ),
    filter(() => {
      const state = state$.value
      const ff = selectActualFeatureFlags(state)
      const isStaticSalesDemo = selectIsStaticSalesDemo(state)
      return ff.DEEPFAKE_SERVICE && !isStaticSalesDemo && matchURL(URL_CONST.dashboard.home)
    }),
    switchMap(() => {
      const state = state$.value
      if (!selectHasSelectedCompanyFilterAccess(state))
        return of(GET_DEEPFAKE_ANALYTIC_ASYNC.cancel())
      const companyFilter = selectCompanyFilter(state)?.value
      const feDateRange = selectDateRange(state)

      return api.dashboard
        .getDeepfakeAnalytic(companyFilter, {
          fe_date_range: feDateRange,
          offset: getTZOffset(),
          timezone: getTimezoneId(),
        })
        .pipe(
          map(({ response }) =>
            GET_DEEPFAKE_ANALYTIC_ASYNC.onSuccess({
              data: response,
            })
          ),
          catchError((error) => {
            const errorMessage =
              error.response?.detail ||
              'Failed to fetch deepfake analytics. Please try again later.'
            return of(
              epicsErrorHandler(GET_DEEPFAKE_ANALYTIC_ASYNC.onError, error, [400, 502]),
              addToast({
                message: errorMessage,
                type: 'error',
                id: 'Deepfake_Analytics_Error_Toast',
              })
            )
          }),
          takeUntil(action$.pipe(ofType(GET_DEEPFAKE_ANALYTIC_ASYNC.CANCEL)))
        )
    })
  )

export default combineEpics(createDeepfakeEpic)
